import { render, staticRenderFns } from "./FicheEnfant.vue?vue&type=template&id=cae850d2"
import script from "./FicheEnfant.vue?vue&type=script&lang=js"
export * from "./FicheEnfant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports